(function () {
  function init(root) {
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var filterOn = root.getAttribute('data-color-filter') !== 'false';
    function show(i) {
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== String(i); });
      thumbs.forEach(function (t) {
        if (t.getAttribute('data-thumb') === String(i)) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }
    function visibleFor(el, color) {
      var c = el.getAttribute('data-color');
      return !filterOn || !c || !color || c === color;
    }
    function applyColor(color, preferred) {
      var first = null;
      thumbs.forEach(function (t) {
        var ok = visibleFor(t, color);
        t.hidden = !ok;
        var idx = t.getAttribute('data-thumb');
        if (ok && first === null) first = idx;
        if (ok && preferred !== null && preferred !== undefined && String(preferred) === idx) first = idx;
      });
      var strip = root.querySelector('[data-thumbs]');
      if (strip) {
        var count = 0;
        thumbs.forEach(function (t) { if (!t.hidden) count++; });
        strip.hidden = count < 2;
      }
      if (first === null && slides.length) {
        slides.forEach(function (s) {
          if (first === null && visibleFor(s, color)) first = s.getAttribute('data-slide');
        });
      }
      if (first !== null) show(first);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-thumb')); });
    });

    var radios = root.querySelectorAll('input[type="radio"][name="id"]');
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var now = r.getAttribute('data-price');
        var cmp = r.getAttribute('data-compare');
        var off = r.getAttribute('data-off');
        root.querySelectorAll('[data-price-now]').forEach(function (el) { el.textContent = now; });
        root.querySelectorAll('[data-price-compare]').forEach(function (el) { el.textContent = cmp; el.hidden = !cmp; });
        root.querySelectorAll('[data-price-off]').forEach(function (el) { el.textContent = off ? '-' + off + ' %' : ''; el.hidden = !off; });
        var stockQty = r.getAttribute('data-stock-left');
        root.querySelectorAll('[data-stock-box]').forEach(function (box) {
          var q = box.querySelector('[data-stock-qty]');
          if (q && stockQty) q.textContent = stockQty;
          box.hidden = !stockQty;
        });
        var media = r.getAttribute('data-media');
        applyColor(r.getAttribute('data-color'), media !== '' ? media : null);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      });
    });
  }
  document.querySelectorAll('[data-product-section]').forEach(init);
})();

/* La cuenta atrás del banner vive ahora en sections/promo-bar.liquid */

(function () {
  document.querySelectorAll('[data-offer]').forEach(function (el) {
    var end = el.getAttribute('data-end'), label = el.getAttribute('data-label') || '';
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(end || '');
    if (!m) return;
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var last = new Date(+m[1], +m[2] - 1, +m[3]);
    var days = Math.round((last - today) / 86400000);
    if (days < 0) { el.hidden = true; return; }
    var msg = days === 0 ? '¡último día, termina hoy!' : days === 1 ? 'queda 1 día' : 'quedan ' + days + ' días';
    var out = el.querySelector('[data-offer-days]');
    if (out) out.textContent = '(' + label + ' · ' + msg + ')';
  });
})();

/* ===== Mini-carrito, añadir sin recargar, filtros y reveal ===== */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var toast = document.querySelector('[data-cart-toast]');
  var lastFocus = null, toastTimer = null, cartData = null;
  var cfg = drawer ? drawer.dataset : {};
  var URLS = {
    add: cfg.addUrl || '/cart/add.js', change: cfg.changeUrl || '/cart/change.js',
    get: cfg.getUrl || '/cart.js', cart: cfg.cartUrl || '/cart', shop: cfg.shopUrl || '/collections/all'
  };

  function money(cents, cur) {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || 'Error'); e.data = d; throw e; } return d; });
    });
  }
  function showToast(msg) {
    if (!toast) { alert(msg); return; }
    toast.textContent = msg; toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.hidden = true; }, 3200);
  }
  function bump() {
    document.querySelectorAll('.cart-link').forEach(function (l) {
      l.classList.remove('bump'); void l.offsetWidth; l.classList.add('bump');
    });
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = n < 1; });
    var lab = document.querySelector('[data-cart-count-label]'); if (lab) lab.textContent = n > 0 ? '(' + n + ')' : '';
  }

  function render(cart) {
    cartData = cart;
    setCount(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-items]');
    var foot = drawer.querySelector('[data-cart-foot]');
    body.textContent = '';
    if (!cart.items.length) {
      var empty = el('div', 'cd-empty');
      empty.appendChild(el('span', 'big', '🛒'));
      empty.appendChild(el('p', null, 'Tu carrito está vacío. Añade tus productos favoritos y aparecerán aquí.'));
      var a = el('a', 'cta', 'Ver productos'); a.href = URLS.shop;
      empty.appendChild(a); body.appendChild(empty);
      foot.hidden = true;
    } else {
      cart.items.forEach(function (it, i) {
        var row = el('div', 'cd-item'); row.style.animationDelay = (i * 50) + 'ms';
        var img = el('img'); img.alt = ''; img.loading = 'lazy';
        img.src = (it.featured_image && it.featured_image.url) || it.image || '';
        row.appendChild(img);
        var mid = el('div');
        var link = el('a', null, it.product_title); link.href = it.url; mid.appendChild(link);
        if (it.variant_title) mid.appendChild(el('small', null, it.variant_title));
        mid.appendChild(el('div', 'cd-price', money(it.final_line_price, cart.currency)));
        var q = el('div', 'cd-qty');
        var minus = el('button', null, '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Quitar una unidad');
        var plus = el('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Añadir una unidad');
        q.appendChild(minus); q.appendChild(el('span', null, it.quantity)); q.appendChild(plus);
        mid.appendChild(q); row.appendChild(mid);
        var rm = el('button', 'cd-rm', '🗑'); rm.type = 'button'; rm.setAttribute('aria-label', 'Eliminar ' + it.product_title);
        row.appendChild(rm);
        function change(n) {
          row.classList.add('busy');
          getJSON(URLS.change, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: it.key, quantity: n }) })
            .then(function (c) { render(c); })
            .catch(function (e) { row.classList.remove('busy'); showToast(e.message); });
        }
        minus.addEventListener('click', function () { change(it.quantity - 1); });
        plus.addEventListener('click', function () { change(it.quantity + 1); });
        rm.addEventListener('click', function () { change(0); });
        body.appendChild(row);
      });
      drawer.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price, cart.currency);
      foot.hidden = false;
    }
    // envío gratis
    var free = parseInt(cfg.free, 10) || 0;
    var ship = drawer.querySelector('[data-cart-ship]');
    if (free > 0 && cart.items.length) {
      var left = free - cart.total_price;
      ship.hidden = false;
      drawer.querySelector('[data-cart-ship-text]').textContent = left > 0
        ? '🚚 Te faltan ' + money(left, cart.currency) + ' para el envío gratis'
        : '🎉 ¡Tienes el envío gratis!';
      drawer.querySelector('[data-cart-ship-bar]').style.width = Math.min(100, Math.round(cart.total_price / free * 100)) + '%';
    } else { ship.hidden = true; }
  }

  function refresh() { return getJSON(URLS.get, { headers: { Accept: 'application/json' } }).then(render); }

  function openDrawer() {
    if (!drawer) { window.location.href = URLS.cart; return; }
    lastFocus = document.activeElement;
    overlay.hidden = false; drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { overlay.classList.add('on'); drawer.classList.add('on'); });
    document.body.classList.add('cd-lock');
    refresh().catch(function () {});
    setTimeout(function () { var c = drawer.querySelector('[data-cart-close]'); if (c) c.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer) return;
    overlay.classList.remove('on'); drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-lock');
    setTimeout(function () { overlay.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target === overlay) closeDrawer();
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && drawer && drawer.classList.contains('on')) closeDrawer(); });

  function addToCart(body, done) {
    return getJSON(URLS.add, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function () { return refresh(); })
      .then(function () { bump(); if (done) done(true); openDrawer(); })
      .catch(function (err) { if (done) done(false); showToast(err.message || 'No se pudo añadir el producto'); });
  }

  // Botón «Añadir» de las tarjetas
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var label = b.querySelector('[data-add-label]'), orig = label ? label.textContent : '';
    b.disabled = true; if (label) label.textContent = 'Añadiendo…';
    var fd = new FormData(); fd.append('id', b.getAttribute('data-quick-add')); fd.append('quantity', '1');
    addToCart(fd, function (ok) {
      if (ok) { b.classList.add('ok'); if (label) label.textContent = '✓ ¡Añadido!'; }
      setTimeout(function () { b.disabled = false; b.classList.remove('ok'); if (label) label.textContent = orig; }, 1800);
    });
  });

  // Formulario de la página de producto (y botón fijo en móvil)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]') || !window.fetch) return;
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') return;
    e.preventDefault();
    var btns = document.querySelectorAll('button[name="add"]');
    var prev = [];
    btns.forEach(function (x, i) { prev[i] = x.innerHTML; x.disabled = true; });
    if (sub) sub.textContent = 'Añadiendo…';
    addToCart(new FormData(f), function (ok) {
      btns.forEach(function (x, i) { x.disabled = false; x.innerHTML = prev[i]; });
      if (sub && ok) { var t = sub.innerHTML; sub.textContent = '✓ ¡Añadido!'; setTimeout(function () { sub.innerHTML = prev[Array.prototype.indexOf.call(btns, sub)] || t; }, 1600); }
    });
  });

  // Filtros de la tienda
  document.querySelectorAll('[data-shop]').forEach(function (shop) {
    var chips = shop.querySelectorAll('[data-filter]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var mode = c.getAttribute('data-filter');
        chips.forEach(function (o) { var on = o === c; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        shop.querySelectorAll('[data-card]').forEach(function (card) {
          var show = mode === 'all' || card.getAttribute('data-sale') === 'true';
          card.classList.toggle('is-hidden', !show);
        });
      });
    });
  });

  // Aparición al hacer scroll
  var revs = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: .12 });
    revs.forEach(function (r) { io.observe(r); });
  } else { revs.forEach(function (r) { r.classList.add('in'); }); }
})();

/* ===== Barra de unidades vendidas: se llena al verla ===== */
(function () {
  var bars = document.querySelectorAll('[data-stock]');
  if (!bars.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function run(el) {
    el.classList.add('in');
    var num = el.querySelector('[data-stock-num]');
    var target = parseInt(el.getAttribute('data-pct'), 10) || 0;
    if (!num || reduce) return;
    var t0 = null, dur = 1400;
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      num.textContent = Math.round(target * e);
      if (k < 1) requestAnimationFrame(step);
    }
    num.textContent = '0';
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: .4 });
    bars.forEach(function (b) { io.observe(b); });
  } else { bars.forEach(run); }
})();

/* ===== Popup de descuento al hacer scroll ===== */
(function () {
  var pop = document.querySelector('[data-sp]');
  if (!pop) return;
  var KEY = 'ethugo_sp', cfg = pop.dataset;
  var pct = parseInt(cfg.scroll, 10) || 35, days = parseInt(cfg.days, 10) || 7;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var force = /[?&]popup=1/.test(location.search);
  var shown = false, lastFocus = null;

  function store(get, val) {
    try { if (get) return localStorage.getItem(KEY); localStorage.setItem(KEY, val); } catch (e) {}
    return null;
  }
  function blocked() {
    if (force || editor) return false;
    var v = store(true);
    if (!v) return false;
    if (v === 'done') return true;
    var t = parseInt(v, 10);
    return t && (Date.now() - t) < days * 86400000;
  }
  function open() {
    if (shown) return; shown = true;
    window.removeEventListener('scroll', onScroll);
    lastFocus = document.activeElement;
    pop.hidden = false;
    requestAnimationFrame(function () { pop.classList.add('on'); });
    pop.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sp-lock');
    var f = pop.querySelector('input[type=email]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 450);
  }
  function close() {
    pop.classList.remove('on');
    pop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sp-lock');
    setTimeout(function () { pop.hidden = true; }, 380);
    if (!force && !editor && !pop.classList.contains('done')) store(false, String(Date.now()));
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && (window.scrollY / h) * 100 >= pct) open();
  }

  if (blocked()) return;
  if (editor) { setTimeout(open, 600); }
  else window.addEventListener('scroll', onScroll, { passive: true });

  pop.addEventListener('click', function (e) {
    if (e.target === pop || e.target.closest('[data-sp-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('on')) close(); });

  var form = pop.querySelector('form'), err = pop.querySelector('[data-sp-err]');
  function success() {
    pop.classList.add('done');
    store(false, 'done');
    var code = cfg.code;
    if (code) { try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {} }
  }
  if (form) form.addEventListener('submit', function (e) {
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]'); btn.disabled = true; if (err) err.hidden = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) {
        if (/customer_posted=true/.test(r.url)) { success(); return; }
        if (/challenge/.test(r.url)) { form.submit(); return; }
        throw new Error('fail');
      })
      .catch(function () { btn.disabled = false; if (err) { err.hidden = false; } });
  });

  var copy = pop.querySelector('[data-sp-copy]');
  if (copy) copy.addEventListener('click', function () {
    var c = cfg.code || '';
    function ok() { copy.textContent = '✓ Copiado'; setTimeout(function () { copy.textContent = 'Copiar'; }, 1800); }
    if (navigator.clipboard) navigator.clipboard.writeText(c).then(ok, ok); else ok();
  });
})();

/* ===== Cómo empezar: pasos interactivos ===== */
(function () {
  var lists = document.querySelectorAll('[data-steps]');
  if (!lists.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  lists.forEach(function (ol) {
    var steps = Array.prototype.slice.call(ol.querySelectorAll('[data-step]'));
    function setActive(k) {
      steps.forEach(function (li, i) {
        li.classList.toggle('is-done', i < k);
        li.classList.toggle('is-active', i === k);
        var b = li.querySelector('.step-node');
        if (b) b.setAttribute('aria-current', i === k ? 'step' : 'false');
      });
    }
    steps.forEach(function (li, i) {
      var b = li.querySelector('.step-node');
      if (b) b.addEventListener('click', function () { setActive(i); });
      var card = li.querySelector('.step-card');
      if (card) card.addEventListener('click', function () { setActive(i); });
    });
    // Recorrido automático la primera vez que se ve
    function play() {
      if (reduce) { setActive(0); return; }
      var k = 0, timer = setInterval(function () {
        setActive(k);
        if (++k >= steps.length) clearInterval(timer);
      }, 650);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { play(); io.disconnect(); } });
      }, { threshold: .35 });
      io.observe(ol);
    } else { setActive(0); }
  });
})();

/* ===== Preguntas frecuentes: acordeón animado ===== */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-faq]').forEach(function (box) {
    var items = Array.prototype.slice.call(box.querySelectorAll('.faq-item'));
    function panel(d) { return d.querySelector('.faq-a'); }
    function close(d) {
      var p = panel(d);
      if (reduce || !p.animate) { d.open = false; return; }
      var h = p.offsetHeight;
      var a = p.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 260, easing: 'ease' });
      a.onfinish = function () { d.open = false; p.style.height = ''; };
    }
    function open(d) {
      d.open = true;
      var p = panel(d);
      if (reduce || !p.animate) return;
      var h = p.scrollHeight;
      p.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 300, easing: 'ease' });
    }
    items.forEach(function (d) {
      d.querySelector('summary').addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) { close(d); return; }
        items.forEach(function (o) { if (o !== d && o.open) close(o); });
        open(d);
      });
    });
  });
})();

/* ===== Ayuda por correo: estado "Enviando…" ===== */
(function () {
  document.querySelectorAll('.help-form').forEach(function (f) {
    f.addEventListener('submit', function () {
      var b = f.querySelector('.help-btn');
      if (!b || !f.checkValidity()) return;
      b.textContent = b.getAttribute('data-sending') || '…';
      setTimeout(function () { b.disabled = true; }, 0);
    });
  });
})();
